import { DateTime } from "luxon";
import { graphql, useFragment } from "react-relay";
import { StoreRelativeZonedDate_StoreZonedDate$key } from "./__generated__/StoreRelativeZonedDate_StoreZonedDate.graphql";

export function StoreRelativeZonedDate(props: {
  zonedDate: StoreRelativeZonedDate_StoreZonedDate$key;
}) {
  const zonedDate = useFragment(
    graphql`
      fragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {
        isoString
        timezone
      }
    `,
    props.zonedDate
  );

  return DateTime.fromISO(zonedDate.isoString, {
    zone: zonedDate.timezone,
  }).toRelativeCalendar({
    unit: "days",
  });
}
